import { render } from "./Example.vue?vue&type=template&id=1d71279d"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"
script.render = render

export default script